import toggleTemplate from '../templates/toggle.hbs';

class ToggleWidget extends HTMLElement {
    constructor(){
        super();
        this._value = this.hasAttribute('enabled');
        this.render();
    }

    connectedCallback(){
        this.addEventListener('click', this.toggle);
        this.addEventListener('keyup', this.onKeyup);
        this.addEventListener('enable', this.enable);
        this.addEventListener('disable', this.disable);
    }

    get value(){
        return this._value;
    }

    set value(val){
        if (val){
            this.enable();
        } else {
            this.disable();
        }
    }

    render(){
        const tabIndex = this.getAttribute('tabIndex');
        this.setAttribute('tabIndex', tabIndex > 0 ? tabIndex : 0);
        this.innerHTML = toggleTemplate();
    }

    onKeyup = e =>  {
        if (e.code === 'Space') {
            this.toggle();
        } else if (!this.hasAttribute('disabled')) {
            if (e.code === 'ArrowRight') {
                this.enable();
            } else if (e.code === 'ArrowLeft') {
                this.disable();
            }
        }
    }

    toggle = () =>  {
        if (!this.hasAttribute('disabled')) {
            if (this._value) {
                this.disable();
            } else {
                this.enable();
            }
        }
    }

    enable = () => {
        this._value = true;

        document.querySelectorAll(this.dataset.disableTargets).forEach(t => {
            t.removeAttribute('disabled');
            t.dispatchEvent(new Event('disabledChange', {bubbles: true}));
        });

        this.setAttribute('enabled', '');
        this.dispatchEvent(new Event('sdaToggleChange', {bubbles: true}));
        this.dispatchEvent(new Event('change', {bubbles: true}));
    }

    disable = () => {
        this._value = false;

        document.querySelectorAll(this.dataset.disableTargets).forEach(t => {
            t.setAttribute('disabled', 'disabled');
            t.dispatchEvent(new Event('disabledChange', {bubbles: true}));
        });

        this.removeAttribute('enabled');
        this.dispatchEvent(new Event('sdaToggleChange', {bubbles: true}));
        this.dispatchEvent(new Event('change', {bubbles: true}));
    }
}

customElements.define('sinclair-toggle', ToggleWidget);
